const { getOffsetTop } = window.BAO.Utils

class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)
    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    if (!this.externalEls?.top?.exists) return

    if (this.externalEls?.enquiryTab?.exists) {
      const isEnquiryActive =
        this.externalEls?.enquiryTab?.element.getAttribute('aria-selected') ===
        'true'

      if (isEnquiryActive) {
        this.classList.remove('prd-FixedBar-show')
        this.classList.remove('prd-FixedBar-showMobile')
        return
      }
    }

    const topStart = this.externalEls.top.element
    const bottomEnd = this.externalEls.bottom.element
    const topStartY = getOffsetTop(topStart) + topStart.offsetHeight - 300
    const bottomEndY = getOffsetTop(bottomEnd) - window.innerHeight - 300
    const topStartYMobile =
      getOffsetTop(topStart) - this.externalEls.top.element.offsetHeight + 300

    if (this.lastKnownY < topStartYMobile) {
      this.classList.add('prd-FixedBar-showMobile')
    } else {
      this.classList.remove('prd-FixedBar-showMobile')
    }

    if (this.lastKnownY >= topStartY && this.lastKnownY <= bottomEndY) {
      this.classList.add('prd-FixedBar-show')
    } else {
      this.classList.remove('prd-FixedBar-show')
    }
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
